/**
 * turni.js — Helper condivisi per turni dinamici (R54.0).
 *
 * Fornisce:
 *  - `DEFAULT_TURNI_V2`: lista di default (mattina + sera) usata quando il backend
 *    non ha ancora restituito la config org.
 *  - `PRESET_TURNI_V2`: preset per 1, 2, 3 turni (usati nel setup wizard e in Impostazioni).
 *  - `findCurrentTurnoKey(turni, date)`: dato l'orario corrente, ritorna la key del
 *    turno attivo. Se nessun turno matcha (buco orario), ritorna la key del primo
 *    turno del giorno.
 *  - `fetchTurni(api)`: chiama `/orgs/me/turni-config` e ritorna la lista turni v2,
 *    con fallback ai default in caso di errore.
 *  - `getCurrentTurnoKeySync(user)`: fallback sync (usa `window.__TURNI__` se disponibile).
 */

export const DEFAULT_TURNI_V2 = [
  { key: "mattina", label: "Mattina", start_h: 6,  end_h: 14, alert_h: 16 },
  { key: "sera",    label: "Sera",    start_h: 14, end_h: 24, alert_h: 24 },
];

export const PRESET_TURNI_V2 = {
  1: [
    { key: "unico", label: "Turno unico", start_h: 6, end_h: 24, alert_h: 24 },
  ],
  2: [
    { key: "mattina", label: "Mattina", start_h: 6,  end_h: 14, alert_h: 16 },
    { key: "sera",    label: "Sera",    start_h: 14, end_h: 24, alert_h: 24 },
  ],
  3: [
    { key: "mattina",     label: "Mattina",     start_h: 6,  end_h: 12, alert_h: 13 },
    { key: "pomeriggio",  label: "Pomeriggio",  start_h: 12, end_h: 18, alert_h: 19 },
    { key: "sera",        label: "Sera",        start_h: 18, end_h: 24, alert_h: 24 },
  ],
};

export function findCurrentTurnoKey(turni, date = new Date()) {
  const list = Array.isArray(turni) && turni.length > 0 ? turni : DEFAULT_TURNI_V2;
  const h = date.getHours();
  for (const t of list) {
    if (h >= t.start_h && h < t.end_h) return t.key;
  }
  // Buchi (es. 01:00 quando primo turno inizia alle 06): mostra il primo turno del giorno
  return list[0].key;
}

export async function fetchTurni(api) {
  try {
    const { data } = await api.get("/orgs/me/turni-config");
    if (Array.isArray(data?.turni) && data.turni.length > 0) {
      // Cache in window per uso sync (fallback ottimistico)
      try { window.__TURNI__ = data.turni; } catch { /* noop */ }
      return data.turni;
    }
  } catch { /* graceful */ }
  return DEFAULT_TURNI_V2;
}

export function getCachedTurni() {
  try {
    if (Array.isArray(window.__TURNI__) && window.__TURNI__.length > 0) return window.__TURNI__;
  } catch { /* noop */ }
  return DEFAULT_TURNI_V2;
}
